import React from 'react';
import { Reveal, Eyebrow } from './Section';
import { IMAGES } from './constants';
const modules = [{
  n: '01',
  text: 'Cómo funciona el negocio UGC, qué buscan las marcas y cómo empezar aunque no tengas seguidores ni experiencia.'
}, {
  n: '02',
  text: 'Definí tu perfil como creadora, elegí tus nichos, tu estilo de contenido y los servicios que vas a ofrecer.'
}, {
  n: '03',
  text: 'Creá videos que las marcas quieran comprar: estructuras, hooks, guiones, planos, iluminación y edición desde el celular.'
}, {
  n: '04',
  text: 'Construí un portfolio profesional desde cero, incluso si todavía no trabajaste con ninguna marca.'
}, {
  n: '05',
  text: 'Encontrá y contactá +80 marcas, con mensajes, correos y un sistema de seguimiento para generar oportunidades.'
}, {
  n: '06',
  text: 'Precios, paquetes y negociación: aprendé a cobrar en dólares, presentar presupuestos y dejar de regalar tu trabajo.'
}, {
  n: '07',
  text: 'Trabajá profesionalmente con marcas: del brief y las correcciones a la entrega, los derechos de uso y el cobro.'
}, {
  n: '08',
  text: 'Convertí el UGC en una fuente de ingresos sostenible, organizando tus clientes, procesos y crecimiento.'
}];
export function ProductBreakdown() {
  return <section className="w-full bg-sand/50 py-16 sm:py-24" data-id="element-152" data-mp="3t3nckmzyxd2t">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-153" data-mp="1phlqj2zolol">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-154" data-mp="1r2fi6hhc0le">
          <Eyebrow data-id="element-155" data-mp="5s4dkjznu6ls">Qué incluye el producto</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-plum sm:text-4xl" data-id="element-156" data-mp="5tfm0x41w2j8">
            8 módulos paso a paso, del cero al primer cobro
          </h2>
          <p className="mt-4 text-ink/70" data-id="element-157" data-mp="fq25pikn4njo">
            Un ebook práctico y ordenado que te lleva de la mano en cada etapa.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 items-start gap-10 lg:grid-cols-2" data-id="element-158" data-mp="2hhf5jt7r458v">
          <Reveal className="mx-auto w-full max-w-md lg:sticky lg:top-24" data-id="element-159" data-mp="2mfyqbqalzazn">
            <img src={IMAGES.modules} alt="Guía visual de contenido UGC para trabajar con marcas" className="aspect-[4/5] w-full rounded-[1.6rem] object-cover shadow-soft" data-id="element-160" data-mp="2mi2w6ds2ik2k" />
          </Reveal>

          <div className="space-y-3" data-id="element-161" data-mp="2odqglx4u1qg7">
            {modules.map((m, i) => <Reveal key={m.n} delay={i * 0.04} data-id="element-162" data-mp="2jenb6bkxxi7p" data-mpi={i}>
                <div className="flex items-start gap-4 rounded-2xl border border-sand bg-white p-5 transition-colors duration-300 hover:border-coral/40" data-id="element-163" data-mp="2jcspgv1uhm2k">
                  <span className="font-display text-2xl font-semibold text-coral/80" data-id="element-164" data-mp="2sflgqyb11xse">
                    {m.n}
                  </span>
                  <p className="pt-1 text-sm leading-relaxed text-ink/80" data-id="element-165" data-mp="372n33etznenv">{m.text}</p>
                </div>
              </Reveal>)}
          </div>
        </div>
      </div>
    </section>;
}